import AOS from "aos";
import $ from "jquery";
import { useContext, useEffect } from "react";
import { Route, useHistory, withRouter } from "react-router-dom";

import PsContext from "../../context";
import Footer from "./footer/footer";
import FooterBottom from "./footer/footerBottom";
import HeaderLogo from "./header/headerLogo";
// import Slider from "./sliderstatic/slider"
import TopHeader from "./header/topHeader";
import TopMenu from "./header/topMenu";

import { Switch } from "react-router-dom/cjs/react-router-dom.min";
import { SuperSEO } from "react-super-seo";
import Routes from "../index";
import DayOrderSocial from "./footer/dayOrderSocial";
import FooterButton from "./footer/footerButton";
import AnnouncementBar from "./header/AnnouncementBar";

const DefaultLayout = (props) => {
  const context = useContext(PsContext);
  const history = useHistory();

  useEffect(() => {
    context.loadSettings();
  }, []);

  useEffect(() => {
    AOS.init({
      //offset: 200,
      //duration: 600,
      easing: "ease-in-sine",
      delay: 200,
    });

    $("html, body").animate({ scrollTop: 0 });
  }, [props.match.path, props.match.params]);

  const themeStyles = `
    .ps__top__menu{
      background-color:${context.settingValue(
        "web_site_header_bgcolor"
      )} !important;    
    }
  `;

  return (
    <>
      <SuperSEO title={context.settingValue("web_site_meta_title")} lang="en" />
      <style>{themeStyles}</style>
      <TopHeader />
      <HeaderLogo />
      <TopMenu />
      <AnnouncementBar />
      <Switch>
        {Routes.defaultlayout.map((item, i) => {
          return (
            <Route
              path={item.path}
              component={item.component}
              exact={item.exact}
            />
          );
        })}
      </Switch>
      {/* <SettingsOffCanvas /> */}
      {/* <WeatherWidget city="Tirunelveli" /> */}
      <DayOrderSocial />
      <Footer />
      <FooterButton />
      {/* <FooterBottom /> */}
    </>
  );
};

export default withRouter(DefaultLayout);
